import React from 'react';
import { OrderItem, ProductionItem } from 'constants/interface';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  ActionButton,
} from './style';

interface TableRowActionProps {
  productionItem: Omit<ProductionItem, 'orderItem'>
}

const TableRowAction = ({
  productionItem,
}: TableRowActionProps): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  // const { url } = useRouteMatch();

  const finalUrl = `${ROUTES.orders.root}${ROUTES.orders.items.root}/${productionItem.id}`;

  const onDetailsClick = () => {
    breadcrumbNavigator.push({
      label: `${productionItem.product.variety.culture.name} ${productionItem.product.variety.name}`,
      url: finalUrl,
    });
  };

  return (
    <ActionButton
      onClick={() => {
        onDetailsClick();
      }}
    >
      Consultar
    </ActionButton>
  );
};

export default TableRowAction;
